export default __webpack_public_path__ + "static/1f4e73ae4564b290f60d5d5987623237.png";